module.exports = __webpack_public_path__ + "img/Esporodóquios e Conídios 1.edb3748e.webp";